import type { ReturnType, TransportType } from '~/model'

export type PackageConstraint = {
  weight: number
  size: string
}

type ConstraintMap = Partial<Record<TransportType, PackageConstraint>>
export const defaultPackageConstraint: PackageConstraint = {
  weight: 31.5,
  size: '120x60x30',
}
export const getPackageConstraints = (
  isCcc: boolean,
  returnType: ReturnType,
  transportType: TransportType
): PackageConstraint => {
  const packageConstraintMap: Partial<Record<ReturnType, ConstraintMap>> = {
    service_point: {
      parcel: {
        weight: isCcc ? 31.5 : 20,
        size: isCcc ? '120x60x60' : '120x60x30',
      },
    },
    consumer_pickup: {
      parcel: {
        weight: 31.5,
        size: '120x60x30',
      },
    },
    pickup: {
      parcel: {
        weight: 31.5,
        size: '120x60x50',
      },
      pallet: {
        weight: 1000,
        size: '120x100x200',
      },
    },
  }
  return packageConstraintMap[returnType]?.[transportType] || defaultPackageConstraint
}
